<template>
  <span
    :aria-hidden="decorative ? 'true' : null"
    role="img"
    :class="'cat-icon icon icon-' + icon"
    :data-icon-label="iconLabel ? iconLabel : null"
    :aria-label="iconLabel ? iconLabel : icon"
  >
  </span>
</template>
<script lang="ts">
import { Component, Vue, Prop } from "vue-facing-decorator";
import { PropOptions } from "vue";

@Component({ name: "cat-icon" })
export default class CatIcon extends Vue {
  @Prop({
    type: String,
    default: "",
    description: "The icon name as listed in the iconography."
  } as PropOptions<any>)
  readonly icon?: string;
  @Prop({
    type: String,
    description:
      "Accessible name for the icon. By default, the icon name is used."
  } as PropOptions<any>)
  readonly iconLabel?: string;
  @Prop({
    type: Boolean,
    default: true,
    description:
      "The icon is purely decorative and does not provide value for assistive technology."
  } as PropOptions<any>)
  readonly decorative?: boolean;
}
</script>
